import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[store/traffic.js]");

const getDefaultState = () => {
  return {
    limit_type: "none", // "none", "traffic", "acl"
    acc_block_message: "",
    traffic: {
      traffic_block_limitaion_reached: 0,
      traffic_warning_limitation_reached: 0,
      traffic_warning_message: "",
    },
    lang: {},
    /* jshint ignore:start */
    // traffic_warning_message: "reach_month_limit+ 5 +mbytes_mark+month_reached+ [00:17+am_mark+, 08/28/2019]"
    /* jshint ignore:end */
  };
};

const state = getDefaultState();

const mutations = {
  SET_WARNING_MSG(state, obj) {
    state.limit_type = "traffic";
    state.traffic = obj.traffic;
    state.lang = obj.lang;
    log("@mu(SET_WARNING_MSG) state", state);
  },
  SET_ACL_BLOCK_MSG(state, value) {
    state.limit_type = "acl";
    state.acc_block_message = value;
    log("@mu(SET_ACL_BLOCK_MSG) state", state);
  },
  RESET_LIMIT(state) {
    state.limit_type = "none";
    log("@mu(SET_ACL_BLOCK_MSG) state", state);
  },
};

const actions = {
  setLimitInfo: ({ commit }, data) => {
    if (data.acc_block_message) {
      commit("SET_ACL_BLOCK_MSG", data.acc_block_message);
    } else {
      commit("SET_WARNING_MSG", data);
    }
  },
  resetLimit: ({ commit }) => {
    commit("RESET_LIMIT");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
